import { FC } from 'react'

import { getHumanReadableInvoiceNumber } from 'Invoices/utils'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'
import { NotificationHeader } from '../../components/NotificationHeader'

export const InvoiceAutoIssueAccountingLockedHeader: FC<{
  taskId: string
}> = ({ taskId }) => {
  const { manualTask } = useManualTask({ taskId })
  const { invoice, customer } = useInvoiceData(
    (manualTask?.input as TaskInput | undefined)?.invoiceId
  )

  return (
    <NotificationHeader
      data-testid="watchtower.notification.invoiceAutoIssueAccountingLocked.header"
      customer={customer}
      identifier={
        invoice
          ? getHumanReadableInvoiceNumber({
              invoiceNumber: invoice.invoiceNumber,
              invoiceStatus: invoice.status
            })
          : undefined
      }
      title="Auto-issue blocked by accounting lock"
    />
  )
}
